import React from "react";

// COLORS
const COLORS = {
  warning: "#E9A30C",
  error: "#C62828",
  success: "#3F9142",
  info: "#008491",
  accent: "#6267E6",
  special: "#E2323C",
  neutral: "#1f1f1f",
  invalid: "#671d73"
};

const DEFAULT_COLOR = "#000000";

// STATUS GROUPS
const STATUS_GROUPS = {
  warning: [
    "remainder",
    "under_review",
    "pending_approval",
    "unverified",
    "pending",
    "in_progress",
    "queued",
    "processing",
    "open",
    "self_managed",
    "signup",
    "expired"
  ],

  error: [
    "no",
    "deactivated",
    "failed",
    "conflict",
    "failed_error",
    "error",
    "opted-out",
    "rejected",
    "canceled",
    "declined",
    "inactive",
    "disabled",
    "restricted",
    "ignored",
    "deactivated"
  ],

  success: [
    "imported",
    "verified",
    "activated",
    "completed",
    "yes",
    "success",
    "approved",
    "closed",
    "opted-in",
    "active"
  ],

  info: ["user", "open", "self_managed", "signup", "hidden"],

  accent: ["admin", "talent_management", "talent_managed", "elite", "paid"],

  special: ["personal_manager", "personal_managed", "retool_sourced_deal"],

  neutral: ["free"]
};

// BUILD STATUS COLOR MAP
const STATUS_COLORS = Object.entries(STATUS_GROUPS).reduce(
  (acc, [group, statuses]) => {
    statuses.forEach((status) => {
      acc[status] = COLORS[group];
    });
    return acc;
  },
  {
    not_filled: COLORS.neutral,
    failed_invalid_data: COLORS.invalid
  }
);

// HELPERS
const normalizeStatus = (status) =>
  String(status)
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, "_")
    .replace(/^_+|_+$/g, "");

const getStatusColor = (status) => {
  const normalized = normalizeStatus(status);

  if (STATUS_COLORS[normalized]) {
    return STATUS_COLORS[normalized];
  }

  if (normalized.startsWith("failed")) {
    return COLORS.error;
  }

  return DEFAULT_COLOR;
};

// COMPONENT
const StatusPillButtons = ({ status, dot = false }) => {
  if (!status) return "-";

  const color = getStatusColor(status);

  const statusText = String(status).replace(/[_-]/g, " ").toLowerCase();

  return (
    <div
      className="status-pill"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: dot ? 6 : 0,
        padding: "4px 8px",
        fontWeight: 400,
        fontSize: 12,
        lineHeight: "16px",
        letterSpacing: "-0.012px",
        textTransform: "capitalize",
        height: 24,
        width: "max-content",
        borderRadius: 24,
        background: `linear-gradient(0deg, ${color}14 0%, ${color}14 100%), #FFF`,
        color: color,
        border: `1px solid ${color}`
      }}
    >
      {dot && (
        <span
          style={{
            width: 4,
            height: 4,
            borderRadius: "50%",
            backgroundColor: color
          }}
        />
      )}

      {statusText}
    </div>
  );
};

export default StatusPillButtons;
